/* global google */

import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { renderList, columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { geocodeAddress } from 'services/geocoding';
import { withReferer } from 'plugins/contextual-back';
import { error } from 'plugins/toastr';
import { ContactSelector } from './components/ContactSelector';
import * as ContactApi from 'saas/contacts/api';
import { bindCreationGeocoding, bindUpdateGeocoding } from 'saas/customers';

const GEOCODE_OBSERVED_FIELDS = [
  'address.address',
  'address.addressComplement',
  'address.city',
  'address.postalCode',
];

export function list(ctx) {
  const customer = ctx.params.id;
  const referer = `/pco-manager/customers/${customer}/sites`;

  const rowClickedUrl = id => withReferer(`/pco-manager/sites/${id}`, referer);
  const loadNextUrl = `/pco-manager/sites/customer/${customer}/range.json`;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export function create() {
  edit(true);

  bindContactSelector();
}

function bindContactSelector() {
  const $root = $('#contact-selector');
  const $input = $('input[name=contactId]');

  if ($root && $root.length) {
    const customer = $root.data('customer');

    const onSelectContact = evt => {
      if ($input && $input.length) {
        $input.val(evt);
      }
    };

    const onContactAdded = customerId => {
      if ($input && $input.length) {
        $input.val(customerId);
      }
      // render();
    };

    const render = () => {
      ContactApi.getByCustomer(customer).then(contacts => {
        ReactDOM.render(
          <ContactSelector
            customer={customer}
            contacts={contacts}
            onAdded={onContactAdded}
            onSelected={onSelectContact}
            errors={[]}
            defaultSelected={$input.val()}
          />,
          document.getElementById('contact-selector')
        );
      });
    };

    render();
  }
}

export function edit(ctx) {
  const $form = $('.customers form');

  // bind geocoding behavior
  if (ctx && ctx.params && ctx.params.id) {
    bindUpdateGeocoding($form);
  } else {
    bindCreationGeocoding($form);
  }
}

export function bindGeocoding($form) {
  const $geocodeButton = $form.find('button.geocode');
  const $locationInput = $form.find('input[name="location"]');
  // Init map if location set
  const locationVal = $locationInput.val();
  if (locationVal && locationVal.length) {
    const split = locationVal.split(',');
    const location = {
      lat: Number(split[0]),
      lng: Number(split[1]),
    };

    initMapFromLocation(location);
  }

  const displayGeocodingHint = () =>
    $geocodeButton.addClass('red').removeClass('disabled');
  const hideGeocodingHint = () =>
    $geocodeButton.removeClass('red').addClass('disabled');

  // Observing fields triggering geocoding hint
  const observedFieldsSelector = GEOCODE_OBSERVED_FIELDS.map(
    name => `input[name="${name}"]`
  ).join(', ');

  $form.find(observedFieldsSelector).each((index, element) => {
    const $input = $(element);
    $input.change('change keyup', displayGeocodingHint);
  });

  const inputValue = name => $form.find(`input[name="${name}"]`).val();

  // Handling geocoding
  $geocodeButton.off('click').on('click', evt => {
    evt.preventDefault();

    const address = {
      address: inputValue('address.address'),
      city: inputValue('address.city'),
      postal_code: inputValue('address.postalCode'),
    };

    $geocodeButton.addClass('loading');
    geocodeAddress(address)
      .then(
        loc => {
          // Updating maps and input
          const display = `${loc.lat},${loc.lng}`;
          $locationInput.val(display);
          initMapFromLocation(loc);

          // Reset geocoding button state
          hideGeocodingHint();
        },
        _ => error('Impossible de récupérer les coordonnées GPS')
      )
      .then(_ => $geocodeButton.removeClass('loading'));
  });
}

export const unbindGeocoding = $form => {
  $('#map').html('');
};

function initMapFromLocation(loc) {
  const map = new google.maps.Map(document.getElementById('map'), {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    zoom: 12,
    center: loc,
  });

  return new google.maps.Marker({
    position: loc,
    map,
  });
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      width={columnWidth(width, 5)}
      label="Nom du site"
    />,
    <Column
      key="city"
      dataKey="city"
      width={columnWidth(width, 2)}
      label="Ville"
    />,
    <Column
      key="zipcode"
      dataKey="zipcode"
      width={columnWidth(width, 2)}
      label="Code postal"
    />,
    <Column
      key="contact"
      dataKey="contact"
      width={columnWidth(width, 3)}
      label="Contact"
    />,
    <Column
      key="phone"
      dataKey="phone"
      width={columnWidth(width, 3)}
      label="Téléphone"
    />,
    <Column
      key="is_headquarters"
      dataKey="is_headquarters"
      width={columnWidth(width, 1)}
      cellRenderer={renderType}
      label="Statut"
    />,
  ];
}

function renderType(row) {
  const { cellData } = row;

  return cellData ? <div className="ui brown label">Siège</div> : null;
}



// WEBPACK FOOTER //
// ./src/modules/saas/sites/index.js